import React, { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";

const LoadingSpinner: React.FC = () => (
  <div className="flex justify-center items-center h-screen bg-gray-50">
    <div className="flex flex-col items-center gap-4">
      <div className="loading-spinner"></div>
      <span className="text-gray-600 text-sm">読み込み中...</span>
    </div>
  </div>
);

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/about" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
